import * as React from "react";
import { forwardRef } from "react";
const SvgArrowGreyFull = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 10, viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 5L-4.07833e-07 0.669873L-2.92811e-08 9.33013L6 5Z", fill: "#BBBBBB" }));
const ForwardRef = forwardRef(SvgArrowGreyFull);
export default ForwardRef;
